<template>
  <div class="wrapper">
    <div class="breadcrumb">{{$t("join.statement.breadcrumb")}}</div>
    <div class="container">
      <div class="title">{{$t("join.statement.title")}}</div>
      <div class="text" v-html='$t("join.statement.text1")'></div>
      <div class="text text2" v-html='$t("join.statement.text2")'></div>
      <div class="text" v-html='$t("join.statement.text3")'></div>
      <div class="text last" v-html='$t("join.statement.text4")'></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'JoinStatement',
  data () {
    return {
    }
  },
  computed: {
  }
}
</script>

<style scoped lang="stylus">
  @import "~styles/varibles"
  @import "~styles/mixins"
  .wrapper
    width 78%
    .breadcrumb:before
      afterTop()
      width 4px
      height 60%
      top 20%
      background $navBgColor2
    .breadcrumb:after
      afterBottom()
      borderBottom()
      width 100%
      opacity 0.2
    .breadcrumb
      cn()
      font-size 24px
      font-weight bold
      padding 5px 0 5px 20px
      position relative
      margin-bottom 45px
    .container
      box-sizing border-box
      padding 0 23px
      .title
        cn()
        font-size 32px
        font-weight bold
        text-align center
        margin-bottom 40px
      .text
        margin-bottom 25px
        width 100%
        line-height 28px
      .last
        box-sizing border-box
        text-align right
        padding-right 110px
      .text2
        font-weight bold
</style>



// WEBPACK FOOTER //
// src/pages/join/components/Statement.vue